// Furrlane: reveal [data-fl-reveal] elements once as they scroll into view.
// The `fl-js` class is set inline in layout/theme.liquid so nothing flashes before this runs.

const observe = (root = document) => {
  const items = root.querySelectorAll('[data-fl-reveal]:not(.is-in)');
  if (!('IntersectionObserver' in window)) return items.forEach((el) => el.classList.add('is-in'));
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );
  items.forEach((el) => io.observe(el));
};

observe();
// Theme editor re-renders sections in place.
document.addEventListener('shopify:section:load', (e) => observe(e.target));
